import {createSelector} from 'reselect';
import uniqBy from 'lodash/uniqBy';

export const getBrowsedCategories = state =>
  state.art.get('browsedCategories').toArray();

export const getCategoryNames = state => state.art.get('categoryNames');
export const getCategoryNamesJs = state =>
  state.art.get('categoryNames').toJS();

export const getRecentlyUsed = state => state.art.get('recentlyUsed').toArray();

export const getRecentlyUsedArt = state => {
  const cliparts = state.art.get('recentlyUsedArt').toArray().reverse();
  return uniqBy(cliparts, 'id');
};

export const getRecentlyUsedSnapshot = state =>
  state.art.get('recentlyUsedSnapshot').toArray();

export const getCategories = state => state.art.get('categories');

export const getCategoriesJs = createSelector([getCategories], categories =>
  categories.toArray()
);

export const getError = state => state.art.get('error');

export const getRoot = state => state.art.get('root');

export const getLastSearch = state => state.art.get('lastSearch');

export const getClipartSearchAutofillData = state =>
  state.art.get('clipartAutofillData');

export const getSearchHistory = state => state.art.get('searchHistory');

export const getSearchHistoryJs = createSelector(
  [getSearchHistory],
  searchHistory =>
    searchHistory
      .map(keyword => {
        return {k: keyword};
      })
      .toArray()
      .reverse()
);
